import showTopMenuAndArrows from "./showTopMenu.js";

import {
	menu,
	menuBig,
	menuList,
	menuProducts,
	body,
	menuSubtitleBlock,
} from "../services/variables.js";

function hamburger(
	menuFullWhite,
	menuForBigProduct,
	showBigMenu,
	hideMenuList,
	menuDisplayNone,
	overflowScroll,
	overflowHidden,
	show,
	menuHeight
) {
	if (
		menu.classList.contains(menuFullWhite) &&
		!menu.classList.contains(menuForBigProduct)
	) {
		window.addEventListener("scroll", showTopMenuAndArrows);
		menuBig.classList.toggle(showBigMenu);
		menu.classList.toggle(menuFullWhite);
		menuList.classList.toggle(hideMenuList);
		menuProducts.classList.toggle(menuDisplayNone);
		menu.classList.remove(overflowScroll);
		if (window.innerWidth <= 575) {
			menuSubtitleBlock.forEach((block) => {
				block.classList.remove(show);
				block.classList.remove(menuHeight);
			});
		}
	} else if (
		menu.classList.contains(menuFullWhite) &&
		menu.classList.contains(menuForBigProduct)
	) {
		menu.classList.toggle(menuFullWhite);
		menu.classList.toggle(menuForBigProduct);
		menuProducts.classList.toggle(show);
		body.classList.toggle(overflowHidden);
	} else {
		removeEventListener("scroll", showTopMenuAndArrows);
		menuBig.classList.toggle(showBigMenu);
		menu.classList.toggle(menuFullWhite);
		menuList.classList.toggle(hideMenuList);
		menuProducts.classList.toggle(menuDisplayNone);
	}
}
export default hamburger;
